import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useStore } from '@nanostores/react';
import { store } from './state';

const actionColumns: ColumnsType = [
  {
    title: '操作类型',
    dataIndex: 'operationType',
    key: 'operationType',
    render(value) {
      if (value === 1) {
        return '封禁';
      }
      if (value === 2) {
        return '解封';
      }
      return value;
    },
  },
  {
    title: '封禁类型',
    dataIndex: 'banType',
    key: 'banType',
    render(value) {
      if (value === 1) {
        return '信誉分';
      }
      if (value === 2) {
        return '时间';
      }
      return value;
    },
  },
  {
    title: '变更前分数',
    dataIndex: 'beforeCreditScore',
    key: 'beforeCreditScore',
  },
  {
    title: '变更后分数',
    dataIndex: 'afterCreditScore',
    key: 'afterCreditScore',
  },
  {
    title: '封禁结束时间',
    dataIndex: 'afterBanEnd',
    key: 'afterBanEnd',
  },
  {
    title: '原因',
    dataIndex: 'operationReason',
    key: 'operationReason',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
  },
  {
    title: '变化时间',
    dataIndex: 'operationTime',
    key: 'operationTime',
  },
];

export function BanHistory() {
  const state = useStore(store);

  return (
    <div>
      <div style={{ margin: '24px 0', textAlign: 'left' }}>
        <span style={{ display: 'inline-block' }}>后台操作历史</span>
      </div>
      <Table dataSource={state.actionList} columns={actionColumns} />
    </div>
  );
}
